/**
 * Type definitions for firm form components
 * Eliminates `as any` casts by providing proper interfaces
 */

/**
 * Option type for the Front Channel combobox
 */
export interface FrontChannelOption {
  id: string;
  name: string;
  address?: string;
}

/**
 * Option type for the Dialpad Number combobox
 */
export interface DialpadNumberOption {
  id: string;
  display_name: string;
  source_name?: string | null;
}

/**
 * None option constant for comboboxes
 */
export const NONE_OPTION_ID = '__none__' as const;
